import { render, staticRenderFns } from "./ClaimSelect.vue?vue&type=template&id=6dc2cb25&scoped=true"
import script from "./ClaimSelect.vue?vue&type=script&lang=js"
export * from "./ClaimSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc2cb25",
  null
  
)

export default component.exports